import React from 'react';

const SearchResultsPane = ( {children} ) =>
    <div
        data-testid="search-results-pane"
        className="search-results border-b border-solid border-grey-lightest fade-in a-duration-med flex flex-col bg-white w-full overflow-hidden overflow-y-auto mb-4">
        <div
            className="search-results-list overflow-hidden overflow-y-auto scrolling-touch pb-20 md:pb-0">
            {children}
        </div>
    </div>;

export default SearchResultsPane;
